import http from '@/base/api/public'
import querystring from 'querystring'

let apiUrl = require('@/../config/sysConfig')
// スタッフ基本情報申請検索
export const i_0001_query = (userCd) => {
  return http.requestQuickGet(apiUrl.apiUrl_BasicStaffInfo + '?userId=' + userCd)
}
// スタッフ基本情報申請保存
export const i_0001_update = (params, userCd) => {
  return http.requestPost(apiUrl.apiUrl_BasicStaffInfo + '?userCd=' + userCd, params);
}
//最寄り駅/最寄りバス停
export const requestEkiStationGet = (params, type) => {
  if (type == "station") {
    return http.requestGet('/expcgi/?val_htmb=jcgi_station&val_sttypefilter=0000001&val_in_name=' + params)
  } else if (type == "bus") {
    return http.requestGet('/expcgi/?val_htmb=jcgi_busstop&val_sttypefilter=1101100&val_in_name=' + params)
  }
}


// WEBPACK FOOTER //
// ./src/module/api/i_0001.js